import { authenticatedBitswanBackendInstance } from "@/lib/api-client";

export type DashboardNote = {
  markdown: string;
  updated_at: string | null;
  updated_by_email: string;
};

export async function fetchDashboardNote() {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.get("/dashboard/note/");
  return res.data as DashboardNote;
}

export async function saveDashboardNote(markdown: string) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.put("/dashboard/note/", { markdown });
  return res.data as DashboardNote;
}
